/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tags_Threshold_HintInputs */

const he_notifications_tags_threshold_hint = /** @type {(inputs: Notifications_Tags_Threshold_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תקבלו התראה כאשר מחיר מוצר עם התגיות הנבחרות יירד מתחת לסכום שהגדרתם`)
};

const en_notifications_tags_threshold_hint = /** @type {(inputs: Notifications_Tags_Threshold_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll be notified when any product with these tags drops below your target price`)
};

/**
* | output |
* | --- |
* | "You'll be notified when any product with these tags drops below your target price" |
*
* @param {Notifications_Tags_Threshold_HintInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_tags_threshold_hint = /** @type {((inputs?: Notifications_Tags_Threshold_HintInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tags_Threshold_HintInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_tags_threshold_hint(inputs)
	return en_notifications_tags_threshold_hint(inputs)
});